import axios from 'axios';
import headers from "../Header";

let baseUrl = "/sdpi/data-tambahan"

class DataTambahanService {
    getDataHistoryNomorKk(size, page, param) {
        let url = ""
        if (param) {
            url = baseUrl + "/nomor-kk?size=" + size + "&page=" + page + "&" + param
        } else {
            url = baseUrl + "/nomor-kk?size=" + size + "&page=" + page
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

    getDataHistoryNik(kode_prov, kode_kab, kode_kec, kode_desa) {
        let param = ""

        if (kode_prov) {
            param = "?kode_prov=" + kode_prov
        } else if (kode_kab) {
            param = "?kode_kab=" + kode_kab
        } else if (kode_prov) {
            param = "?kode_kec=" + kode_kec
        } else if (kode_prov) {
            param = "?kode_desa=" + kode_desa
        }
        return axios.get(baseUrl + "/nik" + param, {
            headers: headers(),
        });
    }

    getDataHistorySearch(nik, nomor_kk) {
        let param = ""

        if (nik) {
            param = "?nik=" + nik
        } else if (nomor_kk) {
            param = "?nomor_kk=" + nomor_kk
        }
        return axios.get(baseUrl + "/search" + param, {
            headers: headers(),
        });
    }

    postData(data) {
        return axios.post(baseUrl + "/add", data, {
            headers: headers(),
        });
    }

    putData(data) {
        return axios.put(baseUrl + "/update", data, {
            headers: headers(),
        });
    }

    deleteData(data) {
        return axios.delete(baseUrl + "/delete", {
            headers: headers(),
            data: data,
        });
    }

}

export default new DataTambahanService();